import { render, staticRenderFns } from "./Migrating-from-GroupManager-or-PermissionsEx.md?vue&type=template&id=572aa1b5&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports